/* ============================================================
   Ingredients Library — grid panel + filter bar
   ============================================================ */

/* ---- Letter range helper ---- */
function getRange(name) {
  var c = (name || '').trim().charAt(0).toLowerCase();
  if ('abcdef'.indexOf(c) !== -1) return 'a-f';
  if ('ghijkl'.indexOf(c) !== -1) return 'g-l';
  if ('mnopqr'.indexOf(c) !== -1) return 'm-r';
  if ('stuvwxyz'.indexOf(c) !== -1) return 's-z';
  return 'other';
}

/* ============================================================
   PANEL LOGIC
============================================================ */
window.initIngredientsLibrary = function (sectionId) {
  var root = document.getElementById('IngredientsLib-' + sectionId);

  if (!root || root.dataset.bound === 'true') return;
  root.dataset.bound = 'true';

  var grid = document.getElementById('IngredientsGrid-' + sectionId);
  var panel = document.getElementById('IngredientPanel-' + sectionId);
  var slot = document.getElementById('IngredientPanelSlot-' + sectionId);

  var tiles = Array.prototype.slice.call(
    root.querySelectorAll('.ingredients-lib__tile')
  );

  var activeTile = null;
  var lastWidth = window.innerWidth;

  function getColumnCount() {
    var cols = window
      .getComputedStyle(grid)
      .getPropertyValue('grid-template-columns')
      .split(' ')
      .filter(Boolean);

    return cols.length || 1;
  }

  function closePanel() {
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');

    if (activeTile) {
      activeTile.classList.remove('is-active');
    }

    activeTile = null;
  }

  function repositionPanel() {
    if (!activeTile) return;

    var visibleTiles = tiles.filter(function (tile) {
      return !tile.classList.contains('is-hidden');
    });

    var cols = getColumnCount();
    var idx = visibleTiles.indexOf(activeTile);

    if (idx === -1) return;

    var rowEndIdx = Math.min(
      visibleTiles.length - 1,
      (Math.floor(idx / cols) + 1) * cols - 1
    );

    var scrollY = window.pageYOffset;

    visibleTiles[rowEndIdx].insertAdjacentElement('afterend', panel);

    window.scrollTo({
      top: scrollY,
      left: window.pageXOffset,
      behavior: 'instant'
    });
  }

  function openPanel(tile) {

    if (activeTile === tile && panel.classList.contains('is-open')) {
      closePanel();
      return;
    }

    var id = tile.getAttribute('data-ingredient-id');
    var template = root.querySelector(
      'template[data-ingredient-data="' + id + '"]'
    );

    if (!template) return;

    if (activeTile) {
      activeTile.classList.remove('is-active');
    }

    slot.innerHTML = '';
    slot.appendChild(template.content.cloneNode(true));

    activeTile = tile;
    activeTile.classList.add('is-active');

    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');

    repositionPanel();
  }

  tiles.forEach(function (tile) {
    tile.addEventListener('click', function () {
      openPanel(tile);
    });
  });

  panel.querySelectorAll('[data-close-panel]').forEach(function (btn) {
    btn.addEventListener('click', closePanel);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closePanel();
    }
  });

  /* Safari-safe resize */
  window.addEventListener('resize', function () {

    if (window.innerWidth === lastWidth) return;

    lastWidth = window.innerWidth;

    if (panel.classList.contains('is-open')) {
      repositionPanel();
    }
  });

};

/* ============================================================
   FILTER BAR
============================================================ */
window.initIngredientsFilterBar = function (sectionId) {

  var root = document.getElementById('IngredientsLib-' + sectionId);
  var searchInput = document.getElementById('IngredientsSearch-' + sectionId);
  var tabsWrap = document.getElementById('IngredientsAZTabs-' + sectionId);

  if (!root || !searchInput || !tabsWrap) return;

  var tiles = Array.prototype.slice.call(
    root.querySelectorAll('.ingredients-lib__tile')
  );

  var tabs = Array.prototype.slice.call(
    tabsWrap.querySelectorAll('.ingredients-lib__az-tab')
  );

  var activeRange = 'all';
  var activeQuery = '';

  function closePanel() {
    var panel = document.getElementById('IngredientPanel-' + sectionId);

    if (!panel.classList.contains('is-open')) return;

    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');

    tiles.forEach(function (tile) {
      tile.classList.remove('is-active');
    });
  }

  function applyFilters() {

    closePanel();

    tiles.forEach(function (tile) {

      var name = tile.getAttribute('data-name') || '';
      var range = getRange(name);

      var matchesRange =
        activeRange === 'all' || range === activeRange;

      var matchesSearch =
        activeQuery === '' || name.indexOf(activeQuery) !== -1;

      tile.classList.toggle(
        'is-hidden',
        !(matchesRange && matchesSearch)
      );

    });

  }

  searchInput.addEventListener('input', function () {

    activeQuery = searchInput.value
      .trim()
      .toLowerCase();

    applyFilters();

  });

  tabs.forEach(function (tab) {

    tab.addEventListener('click', function () {

      tabs.forEach(function (t) {
        t.classList.remove('is-active');
      });

      tab.classList.add('is-active');

      activeRange = tab.getAttribute('data-range');

      applyFilters();

    });

  });

};